import React from 'react'
import Layout from '../../components/Layout'
import Container from '../../components/Container'
import BodyPlaceholder from '../../components/BodyPlaceholder'
import UnderConstruction from '../../components/UnderConstruction'
import SEO from '../../components/SEO'

const Bulletin = ({ data }) => {
  return (
    <Layout>
      <SEO title="주보 광고 | 소식 - 죠이플 교회" description="Joy Church updates and bulletin info" />
        <UnderConstruction title={`소식 / 주보 광고`} />
    </Layout>
  )
}

export default Bulletin
